import { Entry } from 'contentful';
import { Post } from 'repos/posts';

import PostPreview from 'components/postPreview';

type Props = {
  posts: Entry<Post>[];
};

export default function PostPreviews({ posts }: Props) {
  return (
    <div className="grid grid-cols-1 gap-8 self-stretch md:grid-cols-2">
      {posts.map((post) => (
        <PostPreview key={post.fields.title} post={post} />
      ))}
    </div>
  );
}
